<template>
  <div class="container-fluid max-container">
    <div class="row">
      <Header />
      <section v-if="isEpigenetics" class="recent-ancetry-wrapper">
        <div class="container">
          <div class="row">
            <div class="container d-flex flex-column align-items-center justify-content-center">
              <div class="col-md-10 col-lg-9 col-xl-8 m-5 mx-auto">
                <div class="card mb-3 rounded-4 overflow-hidden">
                  <div class="row g-0">
                    <div class="col-sm-5 d-flex align-items-end position-relative overflow-hidden">
                      <div class="bg-gradient-circle position-absolute z-0 w-75 h-100"></div>
                      <img :src="doctor" class="img-fluid mt-5 mx-auto z-1" alt="" />
                    </div>
                    <div class="col-sm-7">
                      <div class="card-body d-flex flex-column align-items-start justify-content-center h-100 p-4">
                        <h5 class="card-title text-start my-3">Requires an ancestry kit</h5>
                        <p class="card-text text-start">
                          <small class="text-muted">Recent ancestry results are only available for ancestry kits.</small>
                        </p>
                        <router-link :to="{ name: 'HealthStore', query: { tab: 'ancestrykits' } }" class="btn btn-primary">Explore ancestry kits</router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section v-else-if="kitPending" class="recent-ancetry-wrapper">
        <div class="container">
          <div class="row">
            <AncestryLanding />
          </div>
        </div>
      </section>
      <page-loader v-else-if="loadingStatus == 'loading'" />
      <section v-else-if="loadingStatus === 'failed'" class="recent-ancetry-wrapper">
        <div class="container">
          <div class="row">
            <!-- Kits are LD… or U…: only an upload (LT…) has the upload screen, as the pill counts it -->
            <RecentAncestryKitPending
              v-if="!$store.getters.profile.profile.barcode.startsWith('LT')"
              class="max-w-xl m-auto mt-8"
            />
            <RecentAncestryUploadStatus class="max-w-xl m-auto mt-8" v-else />
          </div>
        </div>
      </section>
      <section v-else class="recent-ancetry-wrapper">
        <div class="container">
          <div class="row">
            <RecentAncestryNavigation />
            <router-view />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import Header from "@/components/header/Header.vue";
import PageLoader from "@/components/PageLoader.vue";
import RecentAncestryNavigation from "@/view/ancestry/recent/RecentAncestryNavigation.vue";
import { useLoading } from "@/composables/useLoading";
import { useAutosomalStore } from "@/store/ancestry/autosomal";
import RecentAncestryKitPending from "@/view/ancestry/recent/RecentAncestryKitStatus.vue";
import RecentAncestryUploadStatus from "@/view/ancestry/recent/RecentAncestryUploadStatus.vue";
import doctor from "@/assets/characters/blood-test-inspiration-new.png";
import AncestryLanding from "@/view/ancestry/recent/AncestryLanding.vue";
import { useAncestryKit } from "@/composables/useAncestryKit";
import store from "@/store";
import { computed, watch } from "vue";

const isEpigenetics = computed(() => store.getters.profile?.profile?.barcode?.endsWith('E') === true);
const { pending: kitPending } = useAncestryKit();

const autosomalStore = useAutosomalStore();
const { loadingStatus, finishLoading, failLoading } = useLoading();
// A kit still on its way to results has none to ask for: what to expect shows instead. Asked
// for once the kit isn't pending, which can be after the account's tests have loaded.
let requested = false;
watch(kitPending, (pending) => {
  if (!pending && !isEpigenetics.value && !requested) {
    requested = true;
    autosomalStore.getAutosomalResults().then(finishLoading).catch(failLoading);
  }
}, { immediate: true });
</script>
